/**
 * Deep-merge API solutions with defaults so stable product popup (`detail`) is preserved.
 */
function mergeProductDetail(defaultDetail, apiDetail, product) {
  if (!apiDetail && defaultDetail) {
    return JSON.parse(JSON.stringify(defaultDetail));
  }
  if (!apiDetail) {
    return {
      title: product.title || "",
      image: product.image ? { ...product.image } : { src: "", alt: "" },
      paragraphs: product.description ? [product.description] : [""],
      specifications: [],
    };
  }
  if (!defaultDetail) {
    return JSON.parse(JSON.stringify(apiDetail));
  }

  return {
    ...defaultDetail,
    ...apiDetail,
    title: apiDetail.title || defaultDetail.title || product.title,
    image: {
      ...(defaultDetail.image || {}),
      ...(apiDetail.image || {}),
    },
    paragraphs:
      Array.isArray(apiDetail.paragraphs) && apiDetail.paragraphs.length
        ? apiDetail.paragraphs
        : defaultDetail.paragraphs,
    specifications:
      Array.isArray(apiDetail.specifications) && apiDetail.specifications.length
        ? apiDetail.specifications
        : defaultDetail.specifications,
  };
}

function mergeProduct(defaultProduct, apiProduct) {
  const api = apiProduct || {};
  const merged = {
    ...defaultProduct,
    ...api,
    image: {
      ...(defaultProduct.image || {}),
      ...(api.image || {}),
    },
  };
  merged.detail = mergeProductDetail(defaultProduct.detail, api.detail, merged);
  return merged;
}

export function mergeSolutionsContent(defaults, fromApi) {
  const api = fromApi || {};
  const base = { ...defaults, ...api };
  const defaultDevices = defaults.integratedDevices || {};
  const apiDevices = api.integratedDevices || {};
  const defaultProducts = defaultDevices.products || [];
  const apiProducts = apiDevices.products || [];

  const products = defaultProducts.map((defaultProduct) => {
    const apiProduct = apiProducts.find((p) => p.id === defaultProduct.id);
    return mergeProduct(defaultProduct, apiProduct);
  });

  return {
    ...base,
    integratedDevices: {
      ...defaultDevices,
      ...apiDevices,
      specCheckIcon: apiDevices.specCheckIcon || defaultDevices.specCheckIcon,
      products,
    },
  };
}
